import styled from 'styled-components';
import { blink } from '../../../../feedback/Skeleton';
import { Flex } from '../../../../layout/Flex';

export const StatisticItemSkeleton = styled(Flex)
    .withConfig({ displayName: 'StatisticItemSkeleton' })
    .attrs((props) => ({
        ...props,
        width: { xs: 'calc(50% - 8px)', sm: '100%' },
        height: 66,
        background: 'var(--background-secondary)',
        p: 1.5,
        borderRadius: 2,
    }))`
        animation: ${blink} 2s ease-in-out 0.5s infinite;
    `;
